import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchVisitsByPracticeEfector } from '../api';
import { practicePracticeEfectorVisitsActions } from './actions';

import { getPracticeEfectoresById } from './selectors';

export function* loadVisitsEfector({payload}) {
  const { practicePracticeEfectorVisitsId, filters } = payload;

  const practiceEfectorVisits = yield select(getPracticeEfectoresById, practicePracticeEfectorVisitsId);
  if ( practiceEfectorVisits ) {
    //verificar el tiempo que paso desde que se obtuvo los datos del efector, si paso mas de 5 minutos se vuelve a pedir
    const current_date = new Date();
    const interval = current_date.getTime() - practiceEfectorVisits.updated_at.getTime();
    const elapsed_time =  Math.round(interval/(1000 * 60 * 5));

    if ( practiceEfectorVisits.isNew || elapsed_time ){
      yield call(fetchVisitsByPracticeEfector,  practicePracticeEfectorVisitsId, filters);
    }
  }

}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadVisitsEfectores() {
  yield takeLatest(practicePracticeEfectorVisitsActions.LOAD_PRACTICE_EFECTOR_VISITS, loadVisitsEfector);
}

//=====================================
//  ROOT
//-------------------------------------

export const practiceEfectorVisitsSagas = [
  fork(watchLoadVisitsEfectores),
];
